export default function search(text, query) {
  text = text.toLowerCase();
  query = query.toLowerCase();
  
  return query.split(' ').reduce((match, token) => {
    return match && text.indexOf(token) >= 0;
  }, true);
}